export default __webpack_public_path__ + "static/media/auth-bg.7c3ef65f.png";